// src/pages/Dashboard.js
import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import NavBar from "../components/NavBar/NavBar";
import logo from '../assets/new-logo.png';
import fullLogo from '../assets/new-logo.png';
import WellnessContainer from "../components/WellnessContainer/WellnessContainer";
import EvaluationsList from "../components/EvaluationsList/EvaluationsList";
import EvaluationContainer from "../components/EvaluationContainer/EvaluationContainer";
import TrialFourDay from "../components/InfoModals/TrialFourDay";

// at the top of your file…
import acesLogo from '../assets/sponsors/aces.png';
import globocolLogo from '../assets/sponsors/globocol.png';
import playersHealthLogo from '../assets/sponsors/players_health.png';


function TrialOver() {
  return (
    <div className="web-view" style={{ textAlign: "center", padding: "2rem" }}>
      <img style={{ marginTop: "2rem" }} src={fullLogo} className='trial-logo' alt="SWP logo"/>
      <h1 style={{ marginTop: "1rem" }}>Your Trial Has Ended</h1>
      <p style={{ marginTop: "1rem" }}>To continue using the Sports Wellness Platform, please purchase a subscription.</p>
      <button style={{ marginTop: "0.5rem" }} onClick={() => window.location.href = "/purchase-subscription"} className="btn-primary">
        Purchase Subscription
      </button>
    </div>
  );
}

export default function Dashboard() {
  const [userId, setUserId]             = useState(null);
  const [userFlags, setUserFlags]   = useState(null);
  const [showTrialPopup, setShowTrialPopup] = useState(false);

   const [userPermissions, setUserPermissions] = useState([]);
  
    useEffect(() => {
      // Fetch permissions from localStorage when component mounts
      const permissions = localStorage.getItem('userPermissions');
      if (permissions) {
        try {
          setUserPermissions(JSON.parse(permissions));
        } catch (err) {
          console.error('Failed to parse permissions:', err);
          setUserPermissions([]);
        }
      }
  
      // Listen for storage changes (when user logs in/out in another tab)
      const handleStorageChange = (e) => {
        if (e.key === 'userPermissions') {
          try {
            setUserPermissions(e.newValue ? JSON.parse(e.newValue) : []);
          } catch (err) {
            console.error('Failed to parse permissions from storage event:', err);
          }
        }
      };
  
      window.addEventListener('storage', handleStorageChange);
      return () => window.removeEventListener('storage', handleStorageChange);
    }, []);
  
    // Helper function to check if user has permission
    const hasPermission = (permission) => {
      return userPermissions.includes(permission);
    };
    console.log("permissions:", userPermissions);
  console.log("check:", hasPermission("Evaluation"));
  
  // 1️⃣ grab the logged-in user’s ID
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) setUserId(session.user.id);
    });
  }, []);

  

  // 2️⃣ once we have their ID, check trial/trial_acknowledge/created_at
  useEffect(() => {
    if (!userId) return;
    (async () => {
      const { data: u, error } = await supabase
        .from("users")
        .select("created_at, trial, trial_acknowledge, subscription")
        .eq("id", userId)
        .single();
      if (error || !u) return;
      setUserFlags(u);

      if (u.trial && !u.trial_acknowledge) {
        const created = new Date(u.created_at);
        const days = Math.floor((Date.now() - created) / (1000 * 60 * 60 * 24)) + 1;
        if (days === 4) {
          setShowTrialPopup(true);
        }
      }
    })();
  }, [userId]);

  // 3️⃣ if trial ended and no subscription → show TrialOver
  if (userFlags && !userFlags.trial && !userFlags.subscription) {
    return <TrialOver />;
  }

  const sponsors = [
    { name: 'Moneybox',    logoUrl: acesLogo,    link: 'https://moneybox.com' },
    { name: 'Culture Amp', logoUrl: globocolLogo,  link: 'https://cultureamp.com' },
    { name: 'Clay',        logoUrl: playersHealthLogo,        link: 'https://clay.earth' },
    // …etc
  ];

  return (
    <>
      <NavBar />
      <main className="web-view">
        <div className="dashboard">
          <div className="title-area">
            <img src={logo} className='dashboard-logo' alt="SWP logo"/>
          </div>
          {/* <div className="sponsor-container">
            <span className="sponsor-title">Sponsored by</span>
            <SponsorCarousel sponsors={sponsors} displayDuration={3000} />
          </div> */}
          <div className="dashboard-section">
            <EvaluationContainer/>
          </div>
          <div className="date-section">
            <EvaluationsList showRecent={5}/>
          </div>
          <div className="reflection-section">
            <WellnessContainer/>
          </div>
        </div>
      </main>

      <TrialFourDay
        isOpen={showTrialPopup}
        closeModal={() => setShowTrialPopup(false)}
        userId={userId}
      />
    </>
  );
}
